import type { EditSocialOrderFormValues } from '../../pages/Profile/CreateSocialOrder/ZodValidationSchema'

const trimStr = (s: string) => s.trim()

const stringArraysEqual = (a: string[], b: string[]) => {
  if (a.length !== b.length) return false
  return a.every((v, i) => v === b[i])
}

export function areSocialOrderFormOutputsEqual(
  a: EditSocialOrderFormValues,
  b: EditSocialOrderFormValues,
): boolean {
  if (trimStr(a.title) !== trimStr(b.title)) return false
  if (trimStr(a.description) !== trimStr(b.description)) return false
  if (trimStr(a.problem) !== trimStr(b.problem)) return false
  if (!stringArraysEqual(a.focus, b.focus)) return false
  if (a.is_completed !== b.is_completed) return false
  if (trimStr(a.completion_description) !== trimStr(b.completion_description)) return false
  if (trimStr(a.completion_resource_url) !== trimStr(b.completion_resource_url)) return false
  return true
}

export const isSocialOrderFormUnchanged = (
  current: EditSocialOrderFormValues,
  baseline: EditSocialOrderFormValues,
): boolean => areSocialOrderFormOutputsEqual(current, baseline)
